import { EItemActionType } from "../../interfaces/enum";
import { Item } from "../../interfaces/interfaces";

export type TItemState = {
  trendingItems: Item[];
  recommendedItems: Item[];
  series: Item[];
  movies: Item[];
  bookmarked: Item[];
  loading: boolean;
  calledSaved: boolean;
};

const initialState: TItemState = {
  trendingItems: [],
  movies: [],
  series: [],
  bookmarked: [],
  recommendedItems: [],
  loading: true,
  calledSaved: false,
};

export type TItemAction =
  | {
      type: EItemActionType.LOADING;
      data: boolean;
    }
  | {
      type:
        | EItemActionType.RECOMMENDED_ITEMS
        | EItemActionType.TRENDING_ITEMS
        | EItemActionType.MOVIES
        | EItemActionType.SERIES;
      data: Item[];
    }
  | {
      type: EItemActionType.BOOKMARKED;
      data: Item[] | Item;
    }
  | { type: EItemActionType.REMOVE_BOOKMARK; data: Item }
  | {
      type: EItemActionType.CALLED_SAVED;
      data: boolean;
    };

const itemReducer = (state: TItemState = initialState, action: TItemAction) => {
  switch (action.type) {
    case EItemActionType.LOADING:
      return { ...state, loading: action.data };
    case EItemActionType.RECOMMENDED_ITEMS:
      return { ...state, recommendedItems: action.data, loading: false };
    case EItemActionType.TRENDING_ITEMS:
      return { ...state, trendingItems: action.data, loading: false };
    case EItemActionType.MOVIES:
      return { ...state, movies: action.data, loading: false };
    case EItemActionType.SERIES:
      return { ...state, series: action.data, loading: false };
    case EItemActionType.BOOKMARKED:
      const { data } = action;
      if (Array.isArray(data)) {
        return {
          ...state,
          bookmarked: [...new Set([...state.bookmarked, ...data])],
          loading: false,
        };
      } else {
        return {
          ...state,
          bookmarked: [...new Set([...state.bookmarked, data])],
        };
      }
    case EItemActionType.REMOVE_BOOKMARK:
      const findIndex = state.bookmarked.findIndex(
        (item) => item.title === action.data.title
      );
      const newBookmarked = [
        ...state.bookmarked.slice(0, findIndex),
        ...state.bookmarked.slice(findIndex + 1, state.bookmarked.length),
      ];
      return { ...state, bookmarked: [...new Set(newBookmarked)] };
    case EItemActionType.CALLED_SAVED:
      return {
        ...state,
        calledSaved: action.data,
      };
    default:
      return state;
  }
};

export default itemReducer;
